// Tier-name presets — direct port of mobile/src/utils/tierNames.js so
// the same Settings preset (outglow / cosmic / glow / status /
// hackforums) renames tiers consistently across mobile and web. The
// active preset is persisted to localStorage under 'outglow.tierNamePreset'.

export const TIER_NAME_PRESETS = {
  outglow: {
    label: 'Outglow (original)',
    description: 'Photography / clash language. Default.',
    titles: ['Rookie Frame', 'Spark Shooter', 'Arena Contender', 'Framebreaker', 'Vanguard Creator', 'Icon Maker', 'Clash Legend', 'Mythic Frame'],
    badges: ['Rookie',       'Spark',         'Contender',       'Framebreaker', 'Vanguard',         'Icon',       'Legend',       'Mythic']
  },
  cosmic: {
    label: 'Cosmic',
    description: 'Astronomical progression — small spark to supernova.',
    titles: ['Ember', 'Spark', 'Flare', 'Comet', 'Pulsar', 'Nova', 'Quasar', 'Supernova'],
    badges: ['Ember', 'Spark', 'Flare', 'Comet', 'Pulsar', 'Nova', 'Quasar', 'Supernova']
  },
  glow: {
    label: 'Light & Glow',
    description: 'Photo-native — ember to lighthouse to sun.',
    titles: ['Ember', 'Spark', 'Flame', 'Beacon', 'Lantern', 'Lighthouse', 'Sun', 'Eclipse'],
    badges: ['Ember', 'Spark', 'Flame', 'Beacon', 'Lantern', 'Lighthouse', 'Sun', 'Eclipse']
  },
  status: {
    label: 'Status',
    description: 'Plain status ladder — clear and unfussy.',
    titles: ['Rookie', 'Riser', 'Standout', 'Contender', 'Headliner', 'Icon', 'Legend', 'Mythic'],
    badges: ['Rookie', 'Riser', 'Standout', 'Contender', 'Headliner', 'Icon', 'Legend', 'Mythic']
  },
  hackforums: {
    label: 'HackForums style',
    description: 'Color-name ladder — gray, green, blue, purple, red.',
    titles: ['Neutral', 'Friendly', 'Reputable', 'Notable', 'Recognized', 'Distinguished', 'Influential', 'Renowned'],
    badges: ['Neutral', 'Friendly', 'Reputable', 'Notable', 'Recognized', 'Distinguished', 'Influential', 'Renowned']
  }
};

const STORAGE_KEY = 'outglow.tierNamePreset';
let activePresetKey = 'outglow';
try {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
  if (stored && TIER_NAME_PRESETS[stored]) activePresetKey = stored;
} catch {}

const listeners = new Set();
export const onTierPresetChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export function getTierNamePreset() {
  return TIER_NAME_PRESETS[activePresetKey] || TIER_NAME_PRESETS.outglow;
}
export function getTierNamePresetKey() { return activePresetKey; }

export function setTierNamePreset(key) {
  if (!TIER_NAME_PRESETS[key]) return;
  activePresetKey = key;
  try { localStorage.setItem(STORAGE_KEY, key); } catch {}
  listeners.forEach((fn) => { try { fn(key); } catch {} });
}

export function applyPresetToTier(tier, index) {
  const preset = getTierNamePreset();
  return {
    ...tier,
    title: preset.titles[index] || tier.title,
    badgeLabel: preset.badges[index] || tier.badgeLabel
  };
}
